import React                       from 'react';
import FeatureFeedbackPopupWrapper from '../FeatureFeedback/FeatureFeedbackPopupWrapper.js';

const VXTeaserFeedbackPopup = () => (
        <FeatureFeedbackPopupWrapper additionalClassNames={"vxteaser-feedback__container"} />
);

export default VXTeaserFeedbackPopup;
